module.exports = __webpack_public_path__ + "img/Kamal.5ea7c0cf.jpg";